import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, CardBody, Col, FormGroup, Row, Input, InputGroup, FormText, Alert } from 'reactstrap';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import LoaderButton from '../loader-button/LoaderButton';
// services
import BZAPIService from '../../services/BZAPIService';
//libs
import { useFormFields } from '../../libs/hooksLib';
import { FieldGroup } from '../../libs/formLib';
import { adminIsReadOnlyCheck } from '../../helpers/rbac';
// constants
import SETTINGS from '../../constants/settings';
import Heading from '../common/Heading';
import Loader from '../common/Loader';

const ConfigServiceNow = () => {
  const [isValidUrl, setIsValidUrl] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [fields, handleFieldChange] = useFormFields({
    ssoClientSecret: '',
    ssoClientId: '',
    ssoIssuer: '',
    ssoScope: 'openid email',
    enabled: false
  });
  const [enableProviderData, setenableProviderData] = useState(true);
  const [cognitoId, setCognitoId] = useState('');
  const [tenantId, setTenantId] = useState('');
  const [isShow, setIsShow] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
    async function onLoad() {
      try {
        // Set Managed product if exists
        let settings = await BZAPIService.getSSOStatus(SETTINGS.SERVICE_NOW);
        let accountInfo = await BZAPIService.getAccountInfo();
        const myUserPermissions = await BZAPIService.getMyUserPermissions();
        setIsReadOnly(adminIsReadOnlyCheck(myUserPermissions));

        console.log('account info', accountInfo);
        if (!settings)
          settings = {
            ssoClientSecret: '',
            ssoClientId: '',
            ssoIssuer: '',
            ssoScope: 'openid email groups',
            enabled: false
          };
        fields.ssoClientSecret = settings.ssoClientSecret;
        fields.ssoClientId = settings.ssoClientId;
        fields.ssoIssuer = settings.ssoIssuer;
        fields.ssoScope = settings.ssoScope;
        fields.enabled = settings.enabled;
        setenableProviderData(settings.enabled ? true : false);

        setCognitoId(accountInfo.cognitoAppClientId);
        setTenantId(accountInfo.tenantId);

        setIsLoading(false);
      } catch (e) {
        console.log(e);
        setIsLoading(false);
      }
    }

    onLoad();
  }, []);

  const toggleShow = () => {
    setIsShow(!isShow);
  };

  async function saveConfig() {
    const data = {
      enabled: enableProviderData,
      ssoClientSecret: fields.ssoClientSecret,
      ssoClientId: fields.ssoClientId,
      ssoIssuer: fields.ssoIssuer,
      ssoScope: fields.ssoScope
    };

    return BZAPIService.updateSSOSettings(data);
  }
  async function handleSave() {
    try {
      // validate url
      const validUrl = fields.ssoIssuer.match(
        /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/
      );
      console.log('validUrl', validUrl);
      if (!validUrl) setIsValidUrl(false);
      else setIsValidUrl(true);
      setIsSubmitted(true);
      setIsLoading(true);
      // Validate

      if (!fields.ssoIssuer || !validUrl || !fields.ssoClientId || !fields.ssoClientSecret || !fields.ssoScope) {
        setIsLoading(false);

        return;
      }
      // Check if scope include openid and email
      if (fields.ssoScope.indexOf('openid email') === -1) {
        setIsLoading(false);
        return;
      }
      await saveConfig();
      setIsLoading(false);
      setIsSubmitted(false);
      toast.success(`Settings Saved!`);
    } catch (e) {
      setIsLoading(false);
      toast.error('Failed to save.');
      console.log('e', e);
    }
    // Go back to listing
  }

  const handleeEnableProviderDataChange = e => {
    const enableProviderDataValue = e.target.checked;
    console.log('enableProviderDataValue', enableProviderDataValue);
    enableProviderDataValue === true ? setenableProviderData(true) : setenableProviderData(false);
  };

  if (isLoading && !isSubmitted) return <Loader />;
  return (
    <>
      <Heading
        title="Single Sign-On Configuration"
        subtitle="Specify your Corporate Single Sign-On configuration"
        className="mb-4 mt-3"
        icon="cog"
      />
      {isReadOnly && (
        <Alert color="info">Note: Your user only has read-only access. You will not be able to save any updates.</Alert>
      )}

      <Card>
        <CardBody className="fs--1">
          <p>
            <strong>
              Cognito Client ID:{' '}
              <span className="active" data-testid={'cognito-id'}>
                {cognitoId}
              </span>
            </strong>
          </p>
          <p>
            <strong>
              Tenant ID:{' '}
              <span className="active" data-testid={'tenant-id'}>
                {tenantId}
              </span>
            </strong>
          </p>

          <input
            type="checkbox"
            id="exampleCustomCheckbox"
            label="Enable Provider"
            checked={enableProviderData}
            onChange={e => handleeEnableProviderDataChange(e)}
            className="mb-4"
            data-testid={'enable-provider'}
          />
          <label className="ml-2">Enable Provider</label>
          {/* <FormGroup lg="5"> */}
          <FieldGroup
            type="text"
            label="Client ID"
            id="ssoClientId"
            onChange={handleFieldChange}
            value={fields.ssoClientId}
            placeholder="Client ID"
            help="Client ID or Application ID"
            required
            data-testid={'client-id'}
            feedback="Please specify a valid client ID"
            showFeedback={!fields.ssoClientId && isSubmitted}
          />
          {/* </FormGroup> */}
          <FormGroup lg="5">
            <label>Client Secret</label>
            <InputGroup>
              <Input
                type={isShow ? 'text' : 'password'}
                label="Client Secret"
                id="ssoClientSecret"
                onChange={handleFieldChange}
                value={fields.ssoClientSecret}
                // style={{ marginBottom: '10px' }}
                // help="Client secret"
                required
                data-testid={'client-secret'}
                feedback="Please specify a client secret."
                showFeedback={!fields.ssoClientSecret && isSubmitted}
              />
              <Button onClick={e => toggleShow()} className="ml-2">
                {!isShow ? (
                  <>
                    <FontAwesomeIcon icon={'eye'} />
                  </>
                ) : (
                  <>
                    {/* <FontAwesomeIcon icon="fas fa-eye-slash" /> */}
                    hide
                  </>
                )}
              </Button>
            </InputGroup>
            <FormText color="muted">Client Secret</FormText>
          </FormGroup>
          {/* <FormGroup lg="5"> */}
          <FieldGroup
            type="text"
            label="Issuer URL"
            id="ssoIssuer"
            onChange={handleFieldChange}
            value={fields.ssoIssuer}
            placeholder="Enter issuer url"
            // style={{ marginBottom: '10px' }}
            help="Eg. https://issuer.url"
            required
            data-testid={'issuer-url'}
            feedback="Please specify a valid issuer url."
            showFeedback={
              !fields.ssoIssuer.match(/^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/) &&
              isSubmitted
            }
            // className="mt-2"
          />
          {/* </FormGroup> */}
          {/* <FormGroup lg="5"> */}
          <FieldGroup
            type="text"
            label="Scope"
            id="ssoScope"
            onChange={handleFieldChange}
            value={fields.ssoScope}
            placeholder="Scope"
            help="Customize scope. Required 'openid email'"
            required
            data-testid={'scope'}
            feedback="Please specify a valid scopes seperated by spaces. 'openid email' are required"
            showFeedback={!fields.ssoScope || (fields.ssoScope.indexOf('openid email') === -1 && isSubmitted)}
          />
        </CardBody>
      </Card>
      <Row className="flex-between-center" style={{ marginTop: '40px' }}>
        <Col xs="auto">
          <Button
            block
            color="falcon-danger"
            onClick={() => {
              navigate(-1);
            }}
          >
            Cancel
          </Button>
        </Col>
        <Col xs="auto">
          <LoaderButton
            block
            color="falcon-primary"
            onClick={handleSave}
            name="save-and-add"
            isLoading={isLoading}
            data-testid={'save-btn'}
            disabled={isReadOnly}
          >
            Save changes
          </LoaderButton>
        </Col>
      </Row>
    </>
  );
};

export default ConfigServiceNow;
